import { useMemo, useState } from 'react';
import { HubConnectionBuilder, LogLevel, HubConnectionState } from '@aspnet/signalr';
import { wsEndpoint } from '../Api/helpers';

export const hubStatus = {
    CONNECTING: 'CONNECTING',
    FAILED: 'FAILED',
    CONNECTED: 'CONNECTED',
    DISCONNECTED: 'DISCONNECTED',
    CLOSED: 'CLOSED'
};

const useHub = (hubname, listeners, sendOnStart, autoConnect = true) => {
    const [status, setStatus] = useState(hubStatus.CONNECTING);

    const connection = useMemo(() => {
        const hub = new HubConnectionBuilder()
            .configureLogging(LogLevel.Error)
            .withUrl(`${wsEndpoint}/${hubname}`)
            .build();

        hub.serverTimeoutInMilliseconds = 100000;

        if (listeners) {
            listeners.forEach(l => {
                hub.on(l.type, l.action);
            });
        }

        hub.onclose(() => {
            setStatus(hubStatus.CLOSED);
        });

        if (autoConnect) {
            hub.start()
                .then(() => {
                    setStatus(
                        hub.connectionState === HubConnectionState.Connected
                            ? hubStatus.CONNECTED
                            : hubStatus.DISCONNECTED
                    );
                    if (sendOnStart) {
                        connection.send(sendOnStart.type, sendOnStart.data);
                    }
                })
                .catch(rejected => {
                    setStatus(hubStatus.FAILED);
                    console.error(`Could not connect to ${hubname}.`);
                });
        }
        return hub;
        // eslint-disable-next-line
    }, [hubname]);

    return {
        connection,
        status,
        connect: () => {
            connection
                .start()
                .then(() =>
                    setStatus(
                        connection.connectionState === HubConnectionState.Connected
                            ? hubStatus.CONNECTED
                            : hubStatus.DISCONNECTED
                    )
                )
                .catch(err => {
                    setStatus(hubStatus.FAILED);
                    console.warn(err);
                });
        },
        disconnect: () => {
            connection.stop();
        },
        send: (type, data) => {
            if (connection.connectionState === HubConnectionState.Connected) {
                try {
                    connection.send(type, data);
                } catch (error) {
                    console.error(error);
                }
            } else {
                console.warn(`${hubname} is not connected ${connection}`);
            }
        }
    };
};

export default useHub;
